import { render, staticRenderFns } from "./roomDiagram.vue?vue&type=template&id=067fc19f&scoped=true"
import script from "./roomDiagram.vue?vue&type=script&lang=js"
export * from "./roomDiagram.vue?vue&type=script&lang=js"
import style0 from "./roomDiagram.vue?vue&type=style&index=0&id=067fc19f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067fc19f",
  null
  
)

export default component.exports